import { render, staticRenderFns } from "./InformacionPersonalTabContent.vue?vue&type=template&id=5bc06491"
import script from "./InformacionPersonalTabContent.vue?vue&type=script&lang=js"
export * from "./InformacionPersonalTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports